import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Layout from './components/Layout';
import Home from './pages/Home';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Work from './pages/Work';
import About from './pages/About';
import Services from './pages/Services';
import Schedule from './pages/Schedule';
import CarbonNegativeEra from './pages/CarbonNegativeEra';
import PrideStaff from './pages/PrideStaff';
import Lovenood from './pages/Lovenood';
import LuminousTalent from './pages/LuminousTalent';
import ButlerUniversity from './pages/ButlerUniversity';
import PhilipMcParlane from './pages/PhilipMcParlane';
import WesternChristianAcademy from './pages/WesternChristianAcademy';
import PrideStaffPresentation from './pages/PrideStaffPresentation';
import RokotepisteAICaller from './pages/RokotepisteAICaller';
import TranquilityBHC from './pages/TranquilityBHC';
import AuthenticLabs from './pages/AuthenticLabs';
import AlgenesisLabs from './pages/AlgenesisLabs';
import WeCareStaffing from './pages/WeCareStaffing';
import BeyondDataConsulting from './pages/BeyondDataConsulting';
import PopupTalent from './pages/PopupTalent';
import EducationAssessmentSystem from './pages/EducationAssessmentSystem';
import DiLuccia from './pages/DiLuccia';
import GlobalMouseEffect from './components/GlobalMouseEffect';
import VisitorTracker from './components/VisitorTracker';

function App() {
  const location = useLocation();

  // Track page views for analytics
  useEffect(() => {
    // Send page view to analytics
    const pageTitle = document.title;
    const pageUrl = window.location.href;
    
    // This would typically connect to Google Analytics, but we're just logging for now
    console.log(`Page view: ${pageTitle} at ${pageUrl}`);
    
    // You would implement actual analytics tracking here
    // Example: gtag('config', 'GA_MEASUREMENT_ID', { page_path: location.pathname });
  }, [location]);

  return (
    <>
      <GlobalMouseEffect />
      <Header />
      <Layout>
        <VisitorTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/schedule" element={<Schedule />} />
          
          {/* Disabled pages - redirecting to home */}
          <Route path="/carbon-negative-era" element={<Navigate to="/" replace />} />
          <Route path="/pride-staff" element={<Navigate to="/" replace />} />
          <Route path="/pride-staff-presentation" element={<Navigate to="/" replace />} />
          
          {/* Active client pages */}
          <Route path="/lovenood" element={<Lovenood />} />
          <Route path="/luminous-talent" element={<LuminousTalent />} />
          <Route path="/butler-university" element={<ButlerUniversity />} />
          <Route path="/philip-mcparlane" element={<PhilipMcParlane />} />
          <Route path="/western-christian-academy" element={<WesternChristianAcademy />} />
          <Route path="/rokotepiste-ai-caller" element={<RokotepisteAICaller />} />
          <Route path="/tranquility-bhc" element={<TranquilityBHC />} />
          <Route path="/authentic-labs" element={<AuthenticLabs />} />
          <Route path="/algenesis-labs" element={<AlgenesisLabs />} />
          <Route path="/wecare-staffing" element={<WeCareStaffing />} />
          <Route path="/beyond-data-consulting" element={<BeyondDataConsulting />} />
          <Route path="/popup-talent" element={<PopupTalent />} />
          <Route path="/education-assessment-system" element={<EducationAssessmentSystem />} />
          <Route path="/diluccia" element={<DiLuccia />} />
        </Routes>
      </Layout>
      <Footer />
    </>
  );
}

export default App;